import { useEffect, useState } from "react";
import api from "../../src/api";

export default function AddCreditModal({ recpID, onClose, type, labelName }) {
  const [studentCredit, setStudentCredit] = useState(null);
  const [availableCredit, setAvailableCredit] = useState(null);
  const [transferAmount, setTransferAmount] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    loadCredits();
  }, []);

  const loadCredits = async () => {
    try {
      setLoading(true);
      // Fetch logged-in user’s credit and student’s credit from backend
      const res = await api.fetchcreditoforg(recpID); // your API endpoint
      setAvailableCredit(res.data.available_credit); // logged in user credit
      setStudentCredit(res.data.student_credit); // student credit
    } catch (err) {
      setError("Failed to load credits: " + err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleTransfer = async () => {
    if (!transferAmount || transferAmount <= 0) {
      alert("Please enter a valid credit amount");
      return;
    }
    if (transferAmount > availableCredit) {
      alert("Transfer credit cannot be more than available credit");
      return;
    }

    try {
      await api.transferCredit({
        receipent_id: recpID,
        amount: transferAmount,
        receipent_type: type

      });
      alert("Credit transferred successfully");
      onClose(true); // close and refresh
    } catch (err) {
      
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-30 z-50">
      <div className="bg-white rounded-lg shadow-lg w-96 relative p-6">
        {/* Close button */}
        <button
          onClick={() => onClose(false)}
          className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
        >
          ✕
        </button>

        <h2 className="text-xl font-semibold mb-4">Transfer Credit</h2>

        {loading ? (
          <p>Loading...</p>
        ) : error ? (
          <p className="text-red-500">{error}</p>
        ) : (
          <>
            <div className="mb-3">
              <p className="text-sm">
                <strong>{labelName}’s Current Credit:</strong> {studentCredit}
              </p>
              <p className="text-sm">
                <strong>Your Available Credit:</strong> {availableCredit}
              </p>
            </div>
            <div className="mb-3">
              <label className="block mb-1 text-sm font-medium">
                Enter credit to transfer
              </label>
              <input
                type="number"
                value={transferAmount}
                onChange={(e) => setTransferAmount(Number(e.target.value))}
                className="w-full border rounded px-3 py-2"
                placeholder="Amount"
              />
            </div>
            <div className="flex justify-end space-x-3">
              <button
                onClick={() => onClose(false)}
                className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
              >
                Cancel
              </button>
              <button
                onClick={handleTransfer}
                className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
              >
                Transfer
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
